<div class="modal" id="driversEventAdd" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<div class="mb-3 row">
					<ng-select name="drivers" [(ngModel)]="data.drivers" [multiple]="true">
						<ng-option *ngFor="let item of drivers" [value]="item.id">
							{{ item.last_name }} {{ item.first_name }}
						</ng-option>
					</ng-select>
				</div>
				<div class="form-floating mb-3">
					<select class="form-select" id="type" name="type" [(ngModel)]="data.type" required>
						<option value="{{ item.id }}" *ngFor="let item of types">{{ item.name }}</option>
					</select>
					<label for="type">Rodzaj</label>
				</div>
				<div class="form-floating mb-3">
					<input
						type="datetime-local"
						class="form-control"
						id="date_from"
						name="date_from"
						[appUtcModel]="data.date_from"
						(appUtcModelChange)="data.date_from = $event"
					/>
					<label for="date_from">Data od</label>
				</div>
				<div class="form-floating mb-3">
					<input
						type="datetime-local"
						class="form-control"
						id="date_to"
						name="date_to"
						[appUtcModel]="data.date_to"
						(appUtcModelChange)="data.date_to = $event"
					/>
					<label for="date_to">Data do</label>
				</div>

				<div class="form-floating mb-3">
					<textarea class="form-control" id="comments" name="comments" [(ngModel)]="data.comments"></textarea>
					<label for="comments">Komentarz</label>
				</div>
			</div>
			<div class="modal-footer">
				<div class="btn btn-primary me-3" (click)="save(data)"><i class="fas fa-pencil-alt"></i> Zapisz</div>
			</div>
		</div>
	</div>
</div>
